import { get } from '@/services/fetch'

export const findGalleryDetail = (params) => get('/api/v1/findShareTemplateDetail', params)
